import { apis } from '../../../config';
import { api } from '../../../api/api';
import { checkMasterInfo, masterDispatchWrapper } from '@mail/jmail';
import dayjs from 'dayjs';
export class MethodMap {
    constructor() {
        this.checkPostMail = 'user:listDeliveryHistory';
    }
}
export const watchConf = {
    checkPostMail: { updateStatus: false, cache: false },
};
class MailStatusApiImpl {
    constructor() {
        this.commonConfig = {
            contentType: 'json',
            responseType: 'text',
            method: 'post',
            expectedResponseType: 'json',
        };
        this.name = apis.mailStatusApiImpl;
        this.systemApi = api.getSystemApi();
        this.impl = api.getDataTransApi();
    }
    getConfigForHttp(urlKey, httpConfig) {
        const ret = Object.assign(Object.assign({}, this.commonConfig), httpConfig);
        ret.tag = urlKey;
        ret.cachePolicy = ret.cachePolicy || 'noCache';
        return ret;
    }
    formatDate(timestamp) {
        try {
            if (!timestamp) {
                return '--';
            }
            if (typeof timestamp === 'string') {
                return timestamp;
            }
            const date = new Date(timestamp + 8 * 3600 * 1000);
            return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '-');
        }
        catch (error) {
            return '--';
        }
    }
    mergeMailStatusList(statusList = [], externalStatusList = []) {
        return statusList.map(status => {
            const target = externalStatusList.find(newStatus => newStatus.to === status.to);
            if (!target) {
                return status;
            }
            status.inner = target.inner;
            if (status.result >= 700) {
                return status;
            }
            if (target === null || target === void 0 ? void 0 : target.read) {
                status.result = 109;
                status.modtime = this.formatDate(target.readTime);
                return status;
            }
            return status;
        });
    }
    unpackData(res) {
        const data = res.data;
        if (data && data.code === ('S_OK' || 200)) {
        }
        else {
            res.config.requestFailed = true;
        }
        return data;
    }
    buildUrl1(payloads) {
        const { key, additionalParam, urlPath, noSid, _account } = payloads;
        const splitReq = false;
        const currentUser = this.systemApi.getCurrentUser(_account);
        if (!currentUser) {
            return 'no user';
        }
        const methodMap = new MethodMap();
        let req = {
            func: methodMap[key],
            sid: currentUser.sessionId,
        };
        if (noSid) {
            delete req.sid;
        }
        if ((additionalParam === null || additionalParam === void 0 ? void 0 : additionalParam.sid) === '') {
            additionalParam === null || additionalParam === void 0 ? true : delete additionalParam.sid;
            additionalParam === null || additionalParam === void 0 ? true : delete additionalParam.session;
        }
        console.log('[mail] build api for ' + req.func + '->' + req.sid, currentUser);
        if (additionalParam) {
            req = Object.assign(req, additionalParam);
        }
        const conf = {
            noAddingHost: false,
        };
        const generateUrl = this.impl.buildUrl(this.systemApi.getUrl(urlPath || 'mailOperation', '', splitReq, _account), req, conf);
        return generateUrl;
    }
    buildUrl(key, additionalParam, noSid, _account, urlPath) {
        return this.buildUrl1({ key, additionalParam, urlPath, noSid, _account });
    }
    async doCheckReadStatus1(mid, _account, fetchDeliveryHistory = false) {
        var _a, _b;
        const key = 'checkPostMail';
        const url = this.buildUrl(key, undefined, undefined, _account);
        const data1 = { mid, _subaccount: _account };
        if (fetchDeliveryHistory) {
            data1.pid = mid;
        }
        const apiResponse = await this.impl.post(url, data1, this.getConfigForHttp(key, { url, data: data1, _account }));
        const res = this.unpackData(apiResponse);
        if (!res || res.code !== 'S_OK' || !res.var || res.var.length === 0) {
            return { status: 'FA_MAIL_EXPIRED', tid: '', detail: [] };
        }
        const { var: data = [] } = res;
        const tid = (_a = data[0]) === null || _a === void 0 ? void 0 : _a.tid;
        let newData = [];
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (!isCorpMail) {
            try {
                const sentDate = (_b = data[0]) === null || _b === void 0 ? void 0 : _b.modtime;
                const mailTraceUrl = this.systemApi.getAccountUrl('mailTraceStatus', _account);
                const response = await this.impl.post(mailTraceUrl, { tid, sentDate }, { contentType: 'form', _account });
                const { result } = this.unpackData(response);
                newData = (result === null || result === void 0 ? void 0 : result.data) || [];
            }
            catch (error) {
                newData = [];
            }
        }
        const _data = this.mergeMailStatusList(data, newData);
        let contactMap = {};
        const ckRes = checkMasterInfo();
        if (ckRes === null || ckRes === void 0 ? void 0 : ckRes.isMaster) {
            try {
                const contactStr = _data.map(it => it.to).join(',');
                const contactRes = await masterDispatchWrapper({
                    command: 'SEARCH_CONTACT',
                    params: {
                        query: contactStr,
                        accountId: _account,
                        searchType: 1,
                        withSimpleInfo: false,
                    },
                });
                const list = contactRes.list || [];
                list.forEach((it) => {
                    if (it.emailList && it.emailList[0]) {
                        contactMap[it.emailList[0]] = it;
                    }
                });
            }
            catch (error) {
                contactMap = {};
            }
        }
        return {
            status: res.code,
            tid,
            detail: _data.map(it => {
                var _a;
                return ({
                    result: it.result,
                    email: it.to,
                    rclResult: it.rclResult,
                    contactName: ((_a = contactMap[it.to]) === null || _a === void 0 ? void 0 : _a.name) || it.to,
                    avatar: '',
                    modifiedTime: it.modtime,
                    msgType: it.msgType,
                    mid,
                    tid,
                    inner: it === null || it === void 0 ? void 0 : it.inner,
                    msgid: it === null || it === void 0 ? void 0 : it.msgid,
                });
            }),
            externalDetail: newData,
        };
    }
    async doCheckReadStatus(mid, _account, fetchDeliveryHistory) {
        const statusNetWork = await this.doCheckReadStatus1(mid, _account, fetchDeliveryHistory);
        return Promise.resolve(statusNetWork);
    }
    async getMailReadList(tid, _account) {
        try {
            if (!tid) {
                return {
                    success: false,
                    errorMsg: 'tid is null',
                };
            }
            const url = this.systemApi.getAccountUrl('mailReadList', _account);
            const data = await this.impl.post(url, { tid }, { _account }).then(data => data.data);
            if (data && data.code && data.code.toString() === '200') {
                const timeZone = -(new Date().getTimezoneOffset() / 60);
                const readList = (data.result && data.result.data) || [];
                return {
                    success: true,
                    data: readList.map(item => {
                        const timeZoneDate = this.systemApi.getDateByTimeZone(item.readTime, timeZone);
                        item.readTime = dayjs(timeZoneDate).format('MM-DD HH:mm');
                        item.localReadTime = dayjs(item.localReadTime).format('MM-DD HH:mm');
                        return item;
                    }),
                };
            }
            return {
                success: false,
                errorMsg: '未知错误',
            };
        }
        catch (ex) {
            const errorMsg = typeof ex === 'string' ? ex : (ex && ex.message) || '未知错误';
            return {
                success: false,
                errorMsg,
            };
        }
    }
    init() {
        return this.name;
    }
}
const mailStatusApiImpl = new MailStatusApiImpl();
api.registerLogicalApi(mailStatusApiImpl);
export default mailStatusApiImpl;
